import React from "react";
import BackgroundImage from "gatsby-background-image";
import { convertToBgImage } from "gbimage-bridge";
import { useWindowDimension } from "../utils/useWindowDimension";
import Btn from "../common/btn";

const FeatureProduct = ({ data }) => {
  const { width } = useWindowDimension();
  const color = data.textColor.hex;

  if (width > 860) {
    const bgImgDesktop = convertToBgImage(
      data.imageDesktop.asset.gatsbyImageData
    );

    return (
      <BackgroundImage
        Tag="section"
        style={{
          width: "100%",
          height: "590px",
          backgroundSize: "cover",
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
        }}
        {...bgImgDesktop}
        preserveStackingContext
      >
        <div
          className={`w-full flex-1 h-full bg-center bg-no-repeat bg-cover md:bg-none flex flex-col md:px-10 lg:px-[104px] ${
            data.alignX === "center"
              ? "text-center py-[66px]"
              : "text-left py-[85px]"
          }`}
        >
          <div className={`w-full text-white`}>
            <h1
              className={`block font-sometimesfamily text-[50px] leading-[55px] tracking-[2px] mb-[21px] ${
                data.alignX === "center" ? "w-[742px] mx-auto" : "w-[612px]"
              }`}
              style={{ color: `${color}` }}
            >
              {data.title}
            </h1>
            {data.description && (
              <p
                className={`block w-[553px] text-2xl font-dinnext font-light ${
                  data.alignX === "center" && "mx-auto"
                }`}
                style={{ color: `${color}` }}
              >
                {data.description}
              </p>
            )}
          </div>
          <div
            className={`relative w-fit overflow-visible group mt-[41px] ${
              data.alignX === "center" && "mx-auto"
            }`}
          >
            <Btn
              btnClr={data.buttonColor}
              btnType={data.buttonType}
              btnText={data.buttonText}
              btnLink={data.buttonLink}
            />
          </div>
        </div>
      </BackgroundImage>
    );
  } else if (width < 860) {
    const bgImgMobile = convertToBgImage(
      data.imageMobile.asset.gatsbyImageData
    );

    const height =
      data.alignY === "top" && !data.description ? "h-[557px]" : "h-[686px]";

    return (
      <div
        className={`w-full ${height} bg-cover bg-right-top flex flex-col items-center`}
      >
        <BackgroundImage
          Tag="section"
          style={{
            width: "100%",
            height:
              data.alignY === "top" && !data.description ? "557px" : "686px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            display: "flex",
            flex: "1",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "109px",
          }}
          {...bgImgMobile}
          preserveStackingContext
        >
          <div
            className={`relative flex flex-col w-full px-[28px] pt-[41px] text-white h-full ${
              data.alignX === "center"
                ? "items-center text-center"
                : "items-start text-left"
            } ${data.alignY === "bottom" ? "justify-end" : "justify-start"}`}
          >
            <h1
              className="block text-[35px] font-sometimesfamily tracking-[1.4px] leading-10"
              style={{ color: `${color}` }}
            >
              {data.title}
            </h1>
            {data.description && (
              <p
                className="block text-lg font-dinnext leading-6 mt-5 font-light"
                style={{ color: `${color}` }}
              >
                {data.description}
              </p>
            )}
            <div className="relative mt-[43px]">
              <Btn
                btnClr={data.buttonColor}
                btnType={data.buttonType}
                btnText={data.buttonText}
                btnLink={data.buttonLink}
              />
            </div>
          </div>
        </BackgroundImage>
      </div>
    );
  }
};

export default FeatureProduct;
